import React from 'react';

const InfoBoxOne = ( { title, children } ) => (
	<div className="p-4 bg-blue-100 border-l-4 border-blue-500 text-blue-700">
		<p className="font-bold">{ title }</p>
		<p>{ children }</p>
	</div>
);

export default InfoBoxOne;
